module.exports = __webpack_public_path__ + "static/logo-e122c3c28946221ec5ff4a141f956f24.png";